import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetMediumListResponse = {
  MediumType: string;
  MediumName: string;
  StopOrderCode: string;
  ProgressWorkNum: string;
  ProgressWorkName: string;
  ReceiptEOrderCode: string;
  ReceiptECatalogId: string;
}[];

/**
 * 媒体一覧取得サービス
 * @export GetMediumListService
 * @class GetMediumListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetMediumListService extends PlessJsonResponderSub<GetMediumListResponse> {
  private orderCode: string = null;
  private storeObj: object; // 格納先オブジェクト
  private storeParam: string; // 格納先属性名
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMediumListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param orderCode 受注コード
   * @param obj 格納先オブジェクト
   * @param param 格納先属性名
   * @param f コールバック
   * @memberof GetMediumListService
   */
  execute(
    orderCode: string,
    obj: object,
    param: string,
    f: () => void = null
  ): void {
    this.orderCode = orderCode;
    this.storeObj = obj;
    this.storeParam = param;
    this.calbak = f;
    this.send('KYMW02getMediumList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMediumListService
   */
  success(data: GetMediumListResponse) {
    if (this.storeParam in this.storeObj) this.storeObj[this.storeParam] = data;
    if (this.calbak) this.calbak();
  }
}
